import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  listroot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 28px',
    borderBottom: '1px solid #F2F2F2',
  },
  menuroot: {
    boxShadow: '0px 4px 10px rgba(204, 204, 204, 0.5)',
    background: "#FFF",
    borderRadius: '5px',
  },
  weekmonthcontainer: {
    width: '12.66%',
    display: 'flex',
    flexDirection: 'column',
  },
  monthweekText: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
  },
  time: {
    fontSize: 12,
    lineHeight: '18px',
    color: 'rgba(51, 51, 51, 0.5)',
    marginTop: 6,
  },
  eventname: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
    fontWeight: 600,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginRight: 8
  },
  status: {
    fontSize: 14,
    lineHeight: '24px',
    color: ({ getStatusColor, status }) => getStatusColor(status),
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  btn: {
    width: 150,
    textTransform: "capitalize"
  },
  menuicon: {
    color: '#333',
    "&:hover": {
      color: "#26BBED"
    },
  },
  menuIconButton: {
    background: "#F9F9F9",
  },
  rsvp: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#4F6FAE',
    fontWeight: 400,
    '&:hover': {
      color: '#26BBED',
      cursor: 'pointer',
    },
  },
  textWrapperSmall: {
    width: '12.66%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textWrapper: {
    width: '16.66%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textWrapperLarge: {
    width: '20.66%',
    display: 'flex',
    textOverflow: 'ellipsis',
  },
  iconroot: {
    minWidth: 30,
  },
  redico: {
    color: '#E75F75',
  },
  normico: {
    color: '#333',
  },
  menutextred: {
    color: '#E75F75',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.44px',
  },
  menutext: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.44px',
    color: '#333333',
  },
  listbtn: {
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#eee',
    },
    '&:hover path': {
      stroke: '#26BBED',
    },

    '&:hover p': {
      color: '#26BBED',
    },
    '&:hover div span i': {
      color: '#26BBED',
    },
  },

  listbtnred: {
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#eee',
    },

    '&:hover p': {
      color: '#E75F75',
    },
    '&:hover div span i': {
      color: '#E75F75',
    },
  },
  noContext: {
    marginLeft: 24,
    width: 24
  },
}));